import { render, staticRenderFns } from "./singleReleaseView.vue?vue&type=template&id=55487442&"
import script from "./singleReleaseView.vue?vue&type=script&lang=js&"
export * from "./singleReleaseView.vue?vue&type=script&lang=js&"
import style0 from "./singleReleaseView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55487442')) {
      api.createRecord('55487442', component.options)
    } else {
      api.reload('55487442', component.options)
    }
    module.hot.accept("./singleReleaseView.vue?vue&type=template&id=55487442&", function () {
      api.rerender('55487442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/releaseControl/singleReleaseView.vue"
export default component.exports